"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
var DropDownControl;
(function (DropDownControl) {
    class Config {
        static activeClassName = "active";
        static dropDownItemClassName = "DropDownControl-content-dropdown-inside-item";
        static valueDataName = "value";
        static activeItemClassName = "activeItem";
        static dropDownClassName = "DropDownControl-content-dropdown";
    }
    class Control {
        static trigger(dropdownId, changeCallback) {
            const dropDownElement = DOM_1.DOM.Parser.getHtmlElement(dropdownId);
            this.triggerHideOnOutsideClick(dropdownId);
            this.triggerDropDown(dropDownElement);
            this.triggerChange(dropDownElement, changeCallback);
        }
        static triggerHideOnOutsideClick(dropdownId) {
            window.addEventListener('click', (evt) => {
                const dropDownElement = document.getElementById(dropdownId);
                if (dropDownElement === null || !dropDownElement.classList.contains(Config.activeClassName)) {
                    return;
                }
                const clickedInside = DOM_1.DOM.Parser.parentContainsTheClass(Config.dropDownClassName, evt.target);
                if (clickedInside) {
                    return;
                }
                dropDownElement.classList.remove(Config.activeClassName);
            });
        }
        static getCurrentDropDownValue(dropdownId) {
            const dropDownElement = DOM_1.DOM.Parser.getHtmlElement(dropdownId);
            const activeItem = DOM_1.DOM.Parser.getHtmlElementByClass(Config.activeItemClassName, dropDownElement);
            const value = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.valueDataName, activeItem);
            return (value && Number.isNaN(value) ? parseInt(value) : value) ?? null;
        }
        static triggerDropDown(dropDownElement) {
            dropDownElement.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                dropDownElement.classList.toggle(Config.activeClassName);
            });
        }
        static triggerChange(dropDownElement, changeCallback) {
            const triggers = DOM_1.DOM.Parser.getHtmlElements(Config.dropDownItemClassName, dropDownElement);
            for (let i = 0; i < triggers.length; i++) {
                const trigger = triggers[i];
                trigger.addEventListener('click', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    const valueToPropagate = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.valueDataName, trigger);
                    changeCallback(valueToPropagate, event);
                });
            }
        }
    }
    DropDownControl.Control = Control;
})(DropDownControl || (exports.DropDownControl = DropDownControl = {}));
